import qs from 'query-string';

/**
 * Strip a query param from a location.search-style string.
 *
 * Returns a bare query string with no leading `?`. Callers are responsible
 * for prepending `?` when interpolating into a URL.
 *
 * @example
 *   const search = stripQueryParam(location.search, 'source');
 *   navigate(`${newPath}${search ? `?${search}` : ''}`);
 */
export const stripQueryParam = (search: string, paramName: string): string =>
  qs.stringify({ ...qs.parse(search), [paramName]: undefined });

/**
 * Full-page navigation. Routed through this module so specs can mock it:
 * jsdom defines `window.location` and `location.assign` as non-configurable,
 * so under `--pool=vmThreads` neither can be stubbed directly.
 */
export const assignLocation = (url: string): void => window.location.assign(url);
